// extracted by mini-css-extract-plugin
export default {"customersSec":"Customers_customersSec__eP9IM","customersCont":"Customers_customersCont__DV2sc","customers":"Customers_customers__9byru","scroll":"Customers_scroll__QBMN9"};